import { MultiSelectDynamic, OptionData } from "@/components/form-control/multi-select-dynamic";
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from "@/components/ui/form";
import { useDebounce } from "@/hooks/lib-ui";
import {
  useQueryDecreeInfinite,
  QueryDecreeInfiniteProps,
} from "@/modules/restriction/hooks/use-query-decree-infinite";
import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";

export const DecreeMultipleSelect = ({ required, ...props }: QueryDecreeInfiniteProps) => {
  const [value, setValue] = useState<string>("");
  const searchString = useDebounce(value, 500);
  const { listDecisionFile, setDecreeParams, decreeParams, totalPages, isLoading } = useQueryDecreeInfinite(props);
  const { control } = useFormContext<{ selectedDecrees: OptionData<string>[] }>();

  useEffect(() => {
    setDecreeParams((prevState) => ({
      ...prevState,
      pageIndex: 1,
      filter: prevState.filter.map((item) => {
        if (item.field === "text") {
          return {
            field: "text",
            value: searchString,
          };
        }
        return item;
      }),
    }));
  }, [searchString, setDecreeParams]);

  const loadMoreItems = () => {
    setDecreeParams((prevState) => ({ ...prevState, pageIndex: prevState.pageIndex + 1 }));
  };

  const hasMore = useMemo(() => {
    return decreeParams.pageIndex < totalPages && !isLoading;
  }, [totalPages, decreeParams.pageIndex, isLoading]);

  return (
    <FormField
      control={control}
      name="selectedDecrees"
      render={({ field: { onChange, value } }) => (
        <FormItem>
          <FormLabel>Decrees {required && <span className="text-red-500">*</span>}</FormLabel>
          <FormControl>
            <div>
              <MultiSelectDynamic
                onInputValueChange={setValue}
                options={listDecisionFile}
                onChangeValues={onChange}
                className="w-36"
                classNamePopover="max-w-md"
                placeholder="Decrees"
                loadMoreItems={loadMoreItems}
                hasMore={hasMore}
                isLoading={isLoading}
                selectedItems={value ?? []}
              />
            </div>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
